// extracted by mini-css-extract-plugin
export default {"track":"fakeScrollbar__track__n_wik","grabbed":"fakeScrollbar__grabbed__XTufz","thumb":"fakeScrollbar__thumb__gryHu","hidden":"fakeScrollbar__hidden___wUJ7"};